//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pdf from 'vue-pdf'
import { Button } from 'vant'
import { readbooklistsz } from '@/api/youzheng'
export default {
  metaInfo: { //  这里是给页面修改
    title: '',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes' }
    ]
  },
  name: 'Pdf',
  components: {
    pdf,
    [Button.name]: Button
  },
  data () {
    return {
      pdfSrc: '',
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0,
      pageRotate: 0
    }
  },
  mounted () {
    this.getinfor()
    this.getNumPages('https://www.zjftu.org/youzheng/upload/1/202101271025536.pdf')
  },
  methods: {
    getinfor () {
      readbooklistsz({
        owner_type: '2007',
        typeid: '1',
        pagestart: 0,
        pagesize: 12
      })
    },
    getNumPages (url) {
      var loadingTask = pdf.createLoadingTask(url)
      loadingTask.promise.then(pdf => {
        this.pdfSrc = loadingTask
        this.numPages = pdf.numPages
      }).catch((err) => {
        console.error('pdf加载失败')
      })
    },
    // 上一页函数，
    prePage () {
      var page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },
    // 下一页函数
    nextPage () {
      var page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    },
    // 页面顺时针翻转90度。
    clock () {
      this.pageRotate += 90
    },
    // 页面逆时针翻转90度。
    counterClock () {
      this.pageRotate -= 90
    },
    // 页面加载回调函数，其中e为当前页数
    pageLoaded (e) {
      this.curPageNum = e
    },
    // 其他的一些回调函数。
    pdfError (error) {
      console.error(error)
    },
    scaleBig () {
      this.scale += 10
      this.$refs.wrapper.$el.style.width = parseInt(this.scale) + '%'
    },
    scaleSmall () {
      if (this.scale == 100) {
        return
      }
      this.scale += -10
      this.$refs.wrapper.$el.style.width = parseInt(this.scale) + '%'
      // this.$refs.wrapper.$el.style.transform = "scale(" + this.scale + ")";
    }
  }
}
